import type { PageProps } from '@/types/page';
import { usePage as useInertiaPage } from '@inertiajs/vue3';

export const usePage = useInertiaPage<PageProps>;
